import React from 'react'
import { withRouter } from 'react-router-dom'

import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { AuthContext  } from '../../main/ProvedorAutenticacao'

import UsuarioService from '../../app/service/UsuarioService';

import './resetarSenha.css'

import Logo from './img/ilaw-logo.png'
import capa from './img/capaLogin.png'

class ResetarSenha extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openSpinner: false,
      token: "",
      novaSenha: "",
      confirmarSenha: "",
      mensagem: "",
      erro: "",
			sucesso: '',
			mostrarSenha: '',
			mostrarConfirmacao: ''
    };

		this.usuarioService = new UsuarioService();
	}

  redefinirSenha = async () => {
    this.setState({ mensagem: "", erro: "" });

		if(this.state.novaSenha == '' || this.state.confirmarSenha == '') {
			this.setState({ erro: "Preencha todos os campos corretamente" });
      return;
		}

    if (this.state.novaSenha !== this.state.confirmarSenha) {
      this.setState({ erro: "As senhas não coincidem" });
      return;
    }
		
		this.setState({openSpinner: true});
		await this.usuarioService.redefinirSenha(this.state.token,this.state.novaSenha)
				.then(response => {
					this.setState({openSpinner: false});
					this.setState({sucesso: 'Senha redefinda com sucesso'});
				}).catch(error => {
					this.setState({ openSpinner: false });
					let mensagem = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';
					if (error.response && error.response.data) {
						if (typeof error.response.data === 'string') {
							mensagem = error.response.data;
						} else if (error.response.data.message) {
							mensagem = error.response.data.message;
						} else if (error.response.data.detail) {
							mensagem = error.response.data.detail;
						}
					}

        	this.setState({erro: mensagem});
      });
  }

	componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const token = params.get("token");
		if (token) {
			this.setState({ token });
		}
	}

	render() {
		return (
			<div className="container-full">
				<Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
				{/* LADO ESQUERDO (BANNER) */}
				<div className="left_reseta">
					<img src={capa} alt="Banner" className="banner_reseta-img" />
				</div>

				{/* LADO DIREITO (FORMULÁRIO) */}
				<div className="right_reseta">
					<div className="card_reseta_senha">

						<img src={Logo} alt="iLaw Gestão" className="logo_reseta" />

						<h2 className="titulo_resta">Redefinir Senha</h2>

						<div className="input-container_reseta">
							<input
								type={this.state.mostrarSenha ? "text" : "password"}
								placeholder="Nova senha"
								value={this.state.novaSenha}
								onChange={e => this.setState({ novaSenha: e.target.value })}
								className="input_reseta"
								required
							/>

							<span
								className="toggle-senha_reseta"
								onClick={() => this.setState({ mostrarSenha: !this.state.mostrarSenha })}
							>
								{this.state.mostrarSenha ? "Ocultar" : "Mostrar"}
							</span>
						</div>

						<div className="input-container_reseta">
							<input
								type={this.state.mostrarConfirmacao ? "text" : "password"}
								placeholder="Nova senha"
								value={this.state.confirmarSenha}
								onChange={e => this.setState({ confirmarSenha: e.target.value })}
								className="input_reseta"
								required
							/>

							<span
								className="toggle-senha_reseta"
								onClick={() => this.setState({ mostrarConfirmacao: !this.state.mostrarConfirmacao })}
							>
								{this.state.mostrarConfirmacao ? "Ocultar" : "Mostrar"}
							</span>
						</div>


						<button onClick={this.redefinirSenha} className="botao_reseta">
							Alterar Senha
						</button>
						<br></br>
						<br></br>
						{this.state.erro && (
							<strong className="erro_reseta">{this.state.erro}</strong>
						)}

						{this.state.sucesso && ( 
							<div>
								<strong className="sucesso_reseta">{this.state.sucesso}</strong>
								<br></br>
								<br></br>
								{/* Endereço do sistema por ambiente: REACT_APP_SISTEMA_URL no docker-compose.yml (sem valor, o link não aparece) */}
								{process.env.REACT_APP_SISTEMA_URL && (
									<a href={process.env.REACT_APP_SISTEMA_URL} className="voltarSistema">
										Voltar ao sistema
									</a>
								)}
							</div>
						)}

						{/* RODAPÉ */}
						</div>
						{/* FOOTER DIREITO */}
						<div className="footer_reseta">
							iLaw Gestão © {new Date().getFullYear()} - Todos os direitos reservados
						</div>
				</div>

			</div>
		);
	}
}
ResetarSenha.contextType = AuthContext
export default withRouter (ResetarSenha)